import { withTheme } from "styled-components";

import Frame from "./Frame";

export default withTheme(Frame);

